import script from "./CertificationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationPage.vue?vue&type=script&setup=true&lang=js"

import "./CertificationPage.vue?vue&type=style&index=0&id=caeb84c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caeb84c0"]])

export default __exports__